let $tabs,
    $activeTab,
    $activeMobileTab,
    tabID,
    classTabActive = 'tab--current',
    classMobileTabActive = 'mobile-tab--current';

// switch tabs on user interaction
$('.tab').on('click', function() {
    if (!$(this).hasClass(classTabActive)) {
        $tabs = $(this).closest('.tabs');
        tabID = $(this).data('tab-id');

        // update tabs list
        $(this).addClass(classTabActive).siblings().removeClass(classTabActive);
        // show tab-content
        $tabs.find('.tab-content[data-tab-id="'+ tabID +'"]').show().siblings('.tab-content').hide();
        // update mobile tabs
        $tabs.find('.mobile-tab[data-tab-id="'+ tabID +'"]').addClass(classMobileTabActive).siblings('.mobile-tab').removeClass(classMobileTabActive);
    }
});

$('.mobile-tab').on('click', function() {
    if (!$(this).hasClass(classMobileTabActive)) {
        $tabs = $(this).closest('.tabs');
        tabID = $(this).data('tab-id');

        // update mobile tabs
        $(this).addClass(classMobileTabActive).siblings('.mobile-tab').removeClass(classMobileTabActive);
        // show tab-content
        $tabs.find('.tab-content[data-tab-id="'+ tabID +'"]').show().siblings('.tab-content').hide();
        // update tabs list
        $tabs.find('.tab[data-tab-id="'+ tabID +'"]').addClass(classTabActive).siblings().removeClass(classTabActive);

        // animate scroll to selected tab content
        $('html, body').stop().animate({
            scrollTop: $(this).offset().top - 10
        }, 500, 'easeInOutCubic', function() {
            $(this).blur();
        });
    }
});

// show content for active tab on pageload
$('.tabs').each( function() {
    $tabs = $(this);
    $activeTab = $tabs.find('.tab.'+classTabActive);
    $activeMobileTab = $tabs.find('.mobile-tab.'+classMobileTabActive);

    if ($activeTab.length > 0 && $activeMobileTab.length > 0) {
        tabID = $activeTab.data('tab-id');

        $tabs.find('.tab-content[data-tab-id="'+ tabID +'"]').show();
    } else {
        // if no tab is active, make first tab active
        $activeTab = $tabs.find('.tab:first-child');
        tabID = $activeTab.data('tab-id');
        $activeMobileTab = $tabs.find('.mobile-tab[data-tab-id="'+ tabID +'"]');

        $activeTab.addClass(classTabActive);
        $activeMobileTab.addClass(classMobileTabActive);
        $tabs.find('.tab-content[data-tab-id="'+ tabID +'"]').show();
    }
});
